<template>
  <b-input-group :class="{ 'tc-search-input': true, 'tc-search-input-prepend': position === 'prepend' }">
    <template #prepend>
      <b-input-group-text><span class="bx bx-search-alt"></span></b-input-group-text>
    </template>
    <b-form-input
      v-bind="$attrs"
      :id="$attrs.id + '-input'"
      size=""
      :placeholder="placeholder || $t('common.searchPlaceholder')"
      ref="formInput"
      @input="$emit('input', $event)"
      class="ms-0 ps-0"
    />
  </b-input-group>
</template>
<script>
import { BInputGroup, BFormInput } from 'bootstrap-vue-next';

export default {
  components: { BInputGroup, BFormInput },
  props: {
    position: {
      type: String,
      default: () => 'prepend',
    },
    placeholder: String,
  },
  emits: ['input'],
};
</script>
<script setup>
import { ref } from 'vue';

const formInput = ref(null);

const focus = () => {
  formInput.value.element.focus();
};

defineExpose({
  focus,
});
</script>
